import { defineStore } from "pinia";
import { GuestUser } from "../types/public-booking.type";

interface GuestState {
  guestUser: GuestUser | null;
}

export const useGuestStore = defineStore("guest", {
  state: (): GuestState => ({
    guestUser: null,
  }),
  persist: {
    paths: ["guestUser"],
  },
  actions: {
    setGuestUser(user: GuestUser | null) {
      this.guestUser = user;
    },
  },
});
